import React, { Fragment } from 'react';
import { isDesktop } from 'react-device-detect';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { amountOfCards, qryParam, title, urlAssets, urlEspecial, viewPostal } from '../../Constants'; 

//components
import LateralIzquierdo from '../../ads/LateralIzquierdo';
import LateralDerecho from '../../ads/LateralDerecho';
import Caja3 from '../../ads/Caja3';
import Zocalo  from '../../ads/Zocalo'; 

const CardItem = ({children}) => <div className="col-6 col-md-3 p-0">{children}</div>;

const Home = () => {
    
    const instructions = "Haz click en la imagen, envía una tarjeta y deséale un \n mejor año a tus seres queridos";
    const cardItems = Array.from({length: amountOfCards}, (_, index) => index + 1);

    return (
        <Fragment>
            <main className="container cont-principal px-0 cont-layout">
                <section className="d-flex justify-content-around">
                    {isDesktop && <LateralIzquierdo />}
                    <section className="content mb-0 mb-md-5 mt-4 px-2 px-md-0">
                        <section className="container cont-heading py-2">
                            <div className="mx-auto text-center">
                                <LazyLoadImage
                                    alt={title}
                                    className="img-fluid"
                                    effect="blur"
                                    src={`${urlAssets}/img/bienvenido-2022.png`}
                                />   
                            </div>
                        </section>
                        <section className="container mx-auto pb-3 pt-3 px-2 px-md-0 text-center">
                            <h1 className="d-none">{title}</h1>
                            <p className="bajada">{instructions}</p>             
                        </section>   
                        <section className="container row g-0 pb-4 pt-3 px-3 px-md-0 border-top border-dark">
                            {
                                cardItems.map(i => 
                                    <CardItem key={i}>
                                        <a href={`${urlEspecial}${qryParam}${viewPostal}=${i}`}>
                                            <LazyLoadImage
                                                alt={title}
                                                className="p-1 img-fluid"
                                                effect="blur"
                                                src={`${urlAssets}/img/postal/${i}.png`}
                                            />  
                                        </a>
                                    </CardItem>
                                )
                            }
                        </section>
                    </section>   
                    {isDesktop && <LateralDerecho />}    
                </section>                                        
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                    <Zocalo isDesktop={isDesktop} />
                </section> 
            </main>
            <section className="d-none d-md-block empty-space">
            </section>  
        </Fragment>
    )
}

export default Home;